import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { ProgrammaticBrowserRouter } from '@cortex-shim/programmatic_browser_router.component';
import { SignInModal } from '@public/src/components/sign_in/sign_in_modal.component';
import { createRoot, Root } from 'react-dom/client';
import { Route, Routes } from 'react-router-dom';
import { SpaEventService } from '../app/Services/spaEvents.service';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'SignInModalWrapper';
const NO_SCROLL_CLASS_NAME = 'js-noScroll';

@Component({
	standalone: false,
	selector: 'sign-in-modal-wrapper',
	template: ` <div class="wrapper-container" #${containerElementName}></div> `,
	encapsulation: ViewEncapsulation.None,
})
export class SignInModalWrapperComponent implements OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) containerRef: ElementRef;

	private root: Root;

	constructor(
		private readonly ngZone: NgZone,
		private readonly spaEventService: SpaEventService,
	) {
		// Empty
	}

	ngAfterViewInit() {
		document.body.classList.add(NO_SCROLL_CLASS_NAME);
		this.render();
	}

	ngOnDestroy() {
		document.body.classList.remove(NO_SCROLL_CLASS_NAME);
		this.root?.unmount();
	}

	private async render() {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper useGlobals>
					<ProgrammaticBrowserRouter forceNewHistory>
						<Routes>
							<Route
								path='*'
								element={
									<SignInModal
										__TEMP__onCloseSignIn={() => {
											this.ngZone.run(() => {
												this.spaEventService.onSignInAborted.emit();
											});
										}}
									/>
								}
							/>
						</Routes>
					</ProgrammaticBrowserRouter>
				</CellulaProviderWrapper>,
			);
		});
	}
}
